// extracted by mini-css-extract-plugin
module.exports = {"O_15":"O_O_15__Wg7JN"};